// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

export interface ICount {
    count: number;
}

export interface SortAttr {
    sortAttr: string;
    sortOrder: string;  // 'asc' or 'desc'
}

export const ALPHA_NUMERIC_REGEXP = /^[a-zA-Z0-9]+$/;

// For any of the following regex, \\ matches exactly a \, and \$ matches exactly a $. Therefore,
// \\\$ matches exactly \$.  If the $ is not escaped with a \, then it matches end of line.  Same for
// \. sequence.  \. matches exactly a dot.  and unescaped . means match any single char.  \.? means
// match a single .(dot) or no dot.
// ^ at the start means match beginning of line, while [^abc] means NOT a or b or c.
// (abc|def) means match abc or def, and [^(abc|def)] means NOT abc or def.
// for further information on regular expressions, a good regex page is :
//            https://www.ntu.edu.sg/home/ehchua/programming/howto/Regexe.html
// NOTE: if any of these are changed, changes must also be made in policy_service.py
export const ROOT_REGEX: RegExp = /^(\\\$badclus|\\\$bitmap|\\\$boot|\\\$logfile|\\\$mft|\\\$mftmirr|\\\$secure|\\\$upcase|\\\$volume|\\\$extend|\\windows\\system32|\\windows)/i;
export const VARIABLE_REGEX: RegExp = /^(\${home}|\${appdata}|\${allusersprofile}|\${systemroot}|\${userprofile})/i;
export const FILENAMES_REGEX: RegExp = /^(pagefile.sys|hibernate.sys|\.?aux(\.|$)|\.?clock\$(\.|$)|\.?com[1-9](\.|$)|\.?lpt[1-9](\.|$)|\.?nul(\.|$)|\.?prn(\.|$))/i;

// this regex is (starts with drive letter like C:\ or ${xxx}\,  a filename path that does not include:
//  \ / : * ? " < > | \r \n in any of the folder or filenames
// Here is a little bit of explanation of the regex:
// ^  - beginning of line
// [a-zA-Z]:\\  - Drive Letter
// \${.*}(\\|$)  - Variable like ${HOME}.  may have a \, or be end of line
// ?:[^\\/:*?"<>|\r\n]+\\  any number of char that is not *?"<>|\r\n
// +\\ until you hit a slash
// * any number of these xyz123\ types
// NOTE: if any of these are changed, changes must also be made in policy_service.py
export const FOLDER_NAME_REGEXP: RegExp = /^([a-zA-Z]:\\|\${.*}(\\|$))(?:[^\\/:*?"<>|\r\n]+\\)*[^\\/:*?"<>|\r\n]*$/;
export const UNC_PATH_REGEXP: RegExp = /^(\\\\)([^\r\n<>"\/\\|?*{}](?:(?<![\s.])\\)?)+\r?$/;
export const NO_EXE_OR_DLL_REGEXP: RegExp = /\.(dll|exe|dat)$/i;
export const NO_DOT_EXE_OR_DLL_REGEXP: RegExp = /^(dll|exe|dat)$/i;
export const NO_SPACES_REGEXP: RegExp = /(^ | $)/;
export const OTHER_VARS_REGEXP: RegExp = /^[^${}]+$/; // this matches any $, {, or }
